// extracted by mini-css-extract-plugin
export default {"modalOverlay":"EditModal_modalOverlay__X-N-4","modal":"EditModal_modal__X8SOS","closeButton":"EditModal_closeButton__BuYxD"};